import {
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WSQueries } from "../../../query/WSQuery";
import { queriesExternalBankAccounts } from "@query";
import { selectorExternalBankAccountFullName } from "@selectors/selectorExternalBankAccountFullName";
import { IconInstitution } from "../IconInstitution";

type Props = { accountId: string; skipError?: boolean } & WSElementProps;

export const BankAccount: React.FC<Props> = ({
  accountId,
  skipError,
  ...elementProps
}) => {
  const queryExternalBankAccount =
    queriesExternalBankAccounts.getExternalBankAccount.useQuery({
      bankAccountId: accountId
    });

  return (
    <WSElement {...elementProps}>
      <WSQueries
        queries={{ queryExternalBankAccount }}
        renderLoader={() => (
          <WSElement {...elementProps}>
            <WSLoader.Spinner size="S" />
          </WSElement>
        )}
        renderErrors={skipError ? () => null : undefined}
      >
        {({ queryExternalBankAccount: { data: externalBankAccount } }) => (
          <WSFlexBox.CenterY wrap="nowrap" justify="space-between">
            <WSFlexBox.CenterY wrap="nowrap" gap="M">
              <IconInstitution />
              <WSText kind="ParagraphSm">
                {selectorExternalBankAccountFullName(externalBankAccount)}
              </WSText>
            </WSFlexBox.CenterY>
          </WSFlexBox.CenterY>
        )}
      </WSQueries>
    </WSElement>
  );
};
